import { AfterViewInit, Component, EventEmitter, Input, NgModule, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { AppBaseModule } from '../../modules/app-base.module';
import { SaraPlusFormModule } from '@sp-forms/saraplus-ngx-forms';
import { PrimeNGModule } from '../../modules/primeng.module';
import { Idle, DocumentInterruptSource, EventTargetInterruptOptions } from '@ng-idle/core';
import { Keepalive, NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { SessionTimerModule } from '../session-timer/session-timer.component';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-sesion-timeout',
    templateUrl: './sesion-timeout.component.html',
    styleUrl: './sesion-timeout.component.scss',
    standalone: false
})
export class SessionTimeoutComponent implements OnInit, AfterViewInit, OnDestroy {


  #userIdleService = inject(Idle);
  #keepalive = inject(Keepalive);
  idleState = 'Not started.';
  timedOut = false;
  lastPing: Date = new Date();
  timer: number = 60;
  visible: boolean = false;

  startDate = new Date();
  endDate: Date = new Date();

  @Input() setting: SessionSetting = { idle: 1200, timeout: 60, ping: 60 }
  @Output() ContinueClicked?: EventEmitter<void> = new EventEmitter();
  @Output() SessionExpired?: EventEmitter<void> = new EventEmitter();
  subscriptions = new Subscription()

  ngOnInit(): void {

    // sets an idle timeout of 5 seconds, for testing purposes.
    this.#userIdleService.setIdle(this.setting.idle);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    this.#userIdleService.setTimeout(this.setting.timeout);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.#userIdleService.setInterrupts(this.createCustomInterruptSources(null));



    // sets the ping interval to 15 seconds
    //this.#keepalive.interval(this.setting.ping);

    // this.#keepalive.onPing.subscribe(() => {
    //   if (this.SessionExpired) {
    //     this.ContinueClicked.emit();
    //   }
    // });

  }

  ngAfterViewInit(): void {
    this.subscriptions.add(this.#userIdleService.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'
      this.reset();
      if (this.ContinueClicked) {
        this.ContinueClicked.emit();
      }
      this.visible = false;
    }));

    this.subscriptions.add(this.#userIdleService.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      setTimeout(() => {
        if (this.SessionExpired) {
          this.SessionExpired.emit();
        }
        this.visible = false;
      }, 1000);
    }));

    this.subscriptions.add(this.#userIdleService.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!'
      this.endDate.setTime((new Date()).getTime() + ((this.setting.timeout + 2) * 1000));
      this.visible = true;
    }));

    this.subscriptions.add(this.#userIdleService.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!'
      this.timer = countdown;
    }));

    this.subscriptions.add(this.#userIdleService.onInterrupt.subscribe(() => {
      const secDifference = this.getDateDifferenceInSeconds(this.lastPing, new Date());
      if ((this.setting.ping ?? 60) <= secDifference) {
        this.ContinueClicked.emit();
        this.lastPing = new Date();
      }
      this.visible = false;
    }));
  }

  reset() {
    this.#userIdleService.watch();
    //xthis.idleState = 'Started.';
    this.timedOut = false;
  }

  onContinueClicked() {
    this.reset();
    this.visible = false;
    this.ContinueClicked?.emit();
  }


  stopWatching() {
    this.#userIdleService.stop();
  }

  startWatching() {
    this.#userIdleService.watch()
  }

  restart() {
    //this.#userIdleService.resetTimer();
  }

  createCustomInterruptSources(options: EventTargetInterruptOptions) {
    return [
      new DocumentInterruptSource('keydown mouseup click touchstart touchmove scroll', options)
    ];
  }

  getDateDifferenceInSeconds(date1: Date, date2: Date): number {
    const diffInMs = date2.getTime() - date1.getTime();
    return diffInMs / (1000);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    // Idle is a root singleton (NgIdleKeepaliveModule.forRoot); only stop it so it
    // re-arms cleanly on the next login. Calling its ngOnDestroy() tears down the
    // shared instance and breaks idle detection after the first logout.
    this.stopWatching();
  }
}

export interface SessionSetting {
  idle: number,
  timeout: number,
  ping?: number
}

@NgModule({
  declarations: [
    SessionTimeoutComponent
  ],
  imports: [
    AppBaseModule,
    SaraPlusFormModule,
    PrimeNGModule,
    NgIdleKeepaliveModule.forRoot(),
    SessionTimerModule
  ],
  exports: [
    SessionTimeoutComponent
  ]
})
export class SessionTimeoutModule {

}
